import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import s from './Network.module.css'

export const Network = () => {
	const { t } = useTranslation()

	return (
		<div className={s.Network}>
			<div className={s.NetworkBG}>
				<h3>{t('network')}</h3>
			</div>
			<div className='container'>
				<div className={s.Wrapper}>
					<div className={s.Text}>
						<p className={s.Desc}>
							{t('network-text1')}{' '}
							{t('network-text1.9')}
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}
